import Carousel from "react-bootstrap/Carousel";
import "./carousel.css";

const HeroCarousel = () => {
  return (
    <section className="hero-section">
      <Carousel
        fade
        controls={false}
        indicators={true}
        interval={5000}
        pause={false}
      >
        {/* VIDEO SLIDE */}

        <Carousel.Item>
          <div className="hero-slide">
            <video autoPlay muted loop playsInline className="hero-media">
              <source src="./images/carousel-video.mp4" type="video/mp4" />
            </video>

            <div className="overlay"></div>

            <div className="hero-content">
              <h1>TECH</h1>

              <p>
                Tech empowers innovation by developing smart digital solutions,
                software, and systems that enhance business efficiency,
                connectivity, and user experiences.
              </p>
            </div>
          </div>
        </Carousel.Item>

        {/* IMAGE 1 */}

        <Carousel.Item>
          <div className="hero-slide">
            <img src="./images/carousel-1.jpg" alt="" className="hero-media" />

            <div className="overlay"></div>

            <div className="hero-content">
              <h1>CAPITAL</h1>

              <p>
                Capital drives innovation by investing in technology, talent,
                and ideas to build powerful digital solutions that fuel business
                growth and transformation.
              </p>
            </div>
          </div>
        </Carousel.Item>

        {/* IMAGE 2 */}

        <Carousel.Item>
          <div className="hero-slide">
            <img src="./images/caresoul-3.jpg" alt="" className="hero-media" />

            <div className="overlay"></div>

            <div className="hero-content">
              <h1>STRATEGY</h1>

              <p>
                Strategy defines the roadmap for innovation, guiding technology,
                design, and development to deliver impactful, scalable, and
                result-driven digital solutions.
              </p>
            </div>
          </div>
        </Carousel.Item>
      </Carousel>
    </section>
  );
};

export default HeroCarousel;
